'use client';

import { Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';

import { AppRoutes } from '@/constants/route';
import type { LoginFormModel } from '@/modules/authentication/view-model';
import { NextLinkWrapper } from '@/modules/navigation/presentation';

import { Form } from '@packages/hook-form-wrapper';

export const LoginForm = () => {
	const t = useTranslations('authentication.login.loginForm');

	return (
		<Stack gap="sm" h="100%">
			<Text textStyle="h3">
				{t('title')}
			</Text>
			<Stack
				bg="#F8F8F8"
				borderRadius="lg"
				gap="sm"
				h="100%"
				p="sm"
				pt="md"
			>
				<Form.TextInput<LoginFormModel>
					bg="white"
					label={t('fields.email.label')}
					name="email"
					placeholder={t('fields.email.placeholder')}
					size="lg"
				/>
				<Form.PasswordInput<LoginFormModel>
					bg="white"
					label={t('fields.password.label')}
					name="password"
					placeholder={t('fields.password.placeholder')}
					size="lg"
				/>
				<NextLinkWrapper
					color="gray.100"
					href={AppRoutes.auth.forgotPassword}
					ml="auto"
					textStyle="bodySmall"
				>
					{t('actions.forgotPassword')}
				</NextLinkWrapper>
				<Form.SubmitButton size="lg">
					{t('actions.submit')}
				</Form.SubmitButton>
			</Stack>
		</Stack>
	);
};
